<template>
  <div
    class="n-video-message"
    :class="{
      'n-video-message--left': tooltipPosition === 'right',
      'n-video-message--right': tooltipPosition === 'left',
    }"
  >
    <n-avatar
      size="s"
      :name="message.name"
      :imageUrl="message.avatarUrl"
      v-if="displayAvatar"
      :enableTooltip="enableAvatarTooltip"
      class="n-app-message__avatar"
      :class="{
        'n-video-message__avatar--left': tooltipPosition === 'right',
        'n-video-message__avatar--right': tooltipPosition === 'left',
      }"
    ></n-avatar>
    <n-tooltip :position="tooltipPosition">
      <template #default>
        <video controls class="n-video-message__video">
          <source :src="message.mediaSrc" />
        </video>
      </template>
      <template #message>
        <span>
          {{ getMessageTimestamp(message.timestampUtc) }}
          <n-icon icon="alert" fill="#ff6348" v-if="shouldShowAlertIcon(message)" />
          <n-icon
            icon="tick"
            :fill="isRead(message) ? '#57d272' : '#bdbdbd'"
            v-if="shouldShowTickIcon(message)"
          ></n-icon>
        </span>
      </template>
    </n-tooltip>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import moment from 'moment';
import NIcon from '../../brand/icon/icon.vue';
import NTooltip from '../../control/tooltip/tooltip.vue';
import NAvatar from '../avatar/avatar.vue';
import { VideoMessage, Message } from './message';
import { MessageStatus } from './messageStatus';

defineProps({
  message: {
    type: Object as PropType<VideoMessage>,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPosition: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
});

function getMessageTimestamp(timestamp: Date): string {
  return moment(timestamp).format('HH:mm');
}

function shouldShowAlertIcon(m: Message) {
  return m.status === MessageStatus.DeliveryFailed;
}

function isRead(m: Message) {
  return m.status === MessageStatus.Read;
}

function shouldShowTickIcon(m: Message) {
  switch (m.status) {
    case MessageStatus.DeliverySucceeded:
    case MessageStatus.Read:
    case MessageStatus.Received:
    case MessageStatus.Sent:
      return true;
    default:
      return false;
  }
}
</script>

<style lang="scss" scoped>
.n-video-message {
  padding: 0 0.5em;
  max-width: 392px;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  &__video {
    display: block;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0.2em;
  }
  &--right {
    flex-direction: row-reverse;
  }
  &__avatar {
    flex: 0 0 auto;
    &--left {
      margin-right: 0.5rem;
    }
    &--right {
      margin-left: 0.5rem;
    }
  }
}
</style>
